export default __webpack_public_path__ + "static/dvsa-8156dfbe346b53458234e87202848b9a.png";